<template>
  <div id="matterList">
    <div class="header">
      <div class="search-bar">
        <div class="search-box">
          <van-icon class="search-icon iconfont" class-prefix="icon" name="sousuo"></van-icon>
          <form action="javascript:void(0)"><input type="search" v-model="params.sxmcLike" placeholder="请输入事项名称" @keydown="searchHandle"/></form>
        </div>
        <p class="assistant" @click="searchHandle">搜索</p>
      </div>
      <div class="department-select">
        <p class="select-result">
          <span
              :class="{'open': open && selectorType == 'department'}"
              @click="selectorHandle('department')"
          >{{ params.orgName && selectorObj.orgName != ''? params.orgName : '所属部门'}}</span></p>
        <p class="select-result">
          <span
              :class="{'open': open && selectorType == 'servicer'}"
              @click="selectorHandle('servicer')"
          >{{ params.fwdxName && params.fwdxName != ''? params.fwdxName : '服务对象'}}</span></p>
        <p class="select-result">
          <span
              :class="{'open': open && selectorType == 'events'}"
              @click="selectorHandle('events')"
          >{{ params.sxxzName && params.sxxzName != ''? params.sxxzName : '事项性质'}}</span></p>
        <p class="select-result">
          <span
              :class="{'open': open && selectorType == 'pattern'}"
              @click="selectorHandle('pattern')"
          >{{ params.blmsName && params.blmsName != ''? params.blmsName : '办理模式'}}</span></p>
        <DepartmentSelector
            v-if="open && selectorType == 'department'"
            :selectorObj = 'selectorObj'
            :list="orgArray"
            @selectedOrg = "selectedOrg"
            @selectedDepartment = "selectedDepartment"
            @fixedSelector="fixedSelector"
        ></DepartmentSelector>
        <ServiceObject
            :selectOption="selectOption"
            :data="selectorType == 'servicer'? servicers : selectorType == 'events'? eventArray : selectorType == 'pattern'? patterns: []"
            v-if="open && selectorType != 'department'"
            @serviceObjectHandle="serviceObjectHandle"
            @fixedSelector="fixedSelector"
        ></ServiceObject>
      </div>
    </div>
    <div class="box" v-if="!emptyShow">
      <ServiceItemLandscape
        v-for="(item,index) in list"
        :key="index"
        :data="item"
        @matterHandle="matterHandle"
      />
    </div>
    <Error :type="'empty'" v-else></Error>
    <div class="dialog-bg" v-if="open" @click="close"></div>
  </div>
</template>

<script>
import http from "@/utils/http"
import {Toast} from "vant";
import { queryMattersDepartments, queryMobileItemListsData } from "@/api/three-list/index";
export default {
  components: {
    DepartmentSelector: () => import('./components/DepartmentSelector'),
    ServiceObject: () => import('./components/ServiceObject'),
    ServiceItemLandscape: () => import("./components/ServiceItemLandscape"),
  },
  data() {
    return {
      open: false,
      params:{
        sxmcLike: '',//事项名称
        orgId: '',//部门id
        orgName: '',
        fwdxId: '',//服务对象id
        fwdxName: '',
        sxxzId: '',//事项性质id
        sxxzName: '',
        blmsId: '',//办理模式id
        blmsName: '',
        sxbhLike: ''//事项编号搜索内容
      },
      selectorType: '',
      selectorObj: {
        orgSelector: 1,
        selectId: '',
        departmentSelector: {}
      },
      selectOption: {},
      orgArray:[],
      servicers: [],
      eventArray: [],
      patterns: [],
      list:[],
      emptyShow: false
    }
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      //获取数据字典
      this.getDectionary();
    },
    // 获取事项列表数据
    getData() {
      this.emptyShow = false;
      this.mixinShowLoading();
      let params = {
        sxmcLike: this.params.sxmcLike,
        orgId: this.params.orgId,
        fwdxId: this.params.fwdxId,
        sxxzId: this.params.sxxzId,
        blmsId: this.params.blmsId,
        sxbhLike: this.params.sxbhLike
      };
      queryMobileItemListsData(params).then(res => {
        if(res.code && res.code == 200) {
          this.list = res.data || [];
          this.list.length > 0? this.emptyShow = false : this.emptyShow = true
          this.mixinClearLoading();
        }
      })
    },
    // 列表点击事件
    matterHandle(item) {
      this.$router.push({
        path: '/threeList/matter/detail',
        query: {
          id: item.ID
        }
      })
    },
    // 机构点击赋值
    selectedOrg(val) {
      this.selectorObj.orgSelector = val;
    },
    // 部门点击赋值
    selectedDepartment(val) {
      this.selectorObj.departmentSelector = val;
    },
    // 服务对象、事项性质、办理模式选择器点击调用事件
    serviceObjectHandle(val) {
      this.selectOption = val;
    },
    // 确定选择调用事件
    fixedSelector() {
      if (this.selectorType == 'department') {
        if (this.selectorObj.departmentSelector || this.selectorObj.departmentSelector != '') {
          this.params.orgId = this.selectorObj.departmentSelector.ORGID;
          this.params.orgName = this.selectorObj.departmentSelector.ORGNAME;
        } else {
          this.params.orgId = ''
          this.params.orgName = ''
          this.selectorObj.departmentSelector = {}
        }
      } else if (this.selectorType == 'servicer') {
        if (this.selectOption != '') {
          this.params.fwdxId = this.selectOption.id;
          this.params.fwdxName = this.selectOption.text;
        } else {
          this.params.fwdxId = '';
          this.params.fwdxName = '服务对象'
        }
      } else if (this.selectorType == 'events') {
        if (this.selectOption != '') {
          this.params.sxxzId = this.selectOption.id;
          this.params.sxxzName = this.selectOption.text;
        } else {
          this.params.sxxzId = '';
          this.params.sxxzName = '事项性质';
        }
      } else {
        if (this.selectOption != '') {
          this.params.blmsId = this.selectOption.id;
          this.params.blmsName = this.selectOption.text;
        } else {
          this.params.blmsId = '';
          this.params.blmsName = '办理模式'
        }
      }
      this.getData();
      this.close();
    },
    // 选择器点击事件
    selectorHandle(selectorType) {
      if (selectorType == 'servicer') {
        this.selectOption = {
          id: this.params.fwdxId,
          text: this.params.fwdxName
        }
      } else if(selectorType == 'events') {
        this.selectOption = {
          id: this.params.sxxzId,
          text: this.params.sxxzName
        }
      } else if(selectorType == 'pattern') {
        this.selectOption = {
          id: this.params.blmsId,
          text: this.params.blmsName
        }
      }
      if (selectorType != this.selectorType) {
        this.selectorType = selectorType;
        this.openSelector()
      } else {
        if (this.open) {
          this.close()
        } else {
          this.openSelector();
        }
      }
    },
    // 搜索
    searchHandle() {
      this.list = [];
      this.getData();
    },
    // 打开选择器弹窗
    openSelector() {
      this.open = true;
    },
    // 关闭选择器弹窗
    close() {
      this.open = false;
    },
    //  获取数据字典
    getDectionary() {
      const keys = [
        'listOrgType',//部门类别
        'XJDITEMLIST_FWDXM', //服务对象
        'XJDITEMLIST_SXXZM', //事项性质
        'XJDITEMLIST_BJMSM', //办理模式
      ];
      http.get('/param/keys.htm', {keys: keys.join()}).then(resp=>{
        if (!resp || resp.code != 200) {
          Toast(`获取系统参数${dictionaryKey}失败`)
        } else {
          keys.forEach((item, index) => {
            let array = [];
            if (typeof resp.data[item] == 'string') {
              array = JSON.parse(resp.data[item])
            } else {
              array = resp.data[item]
            }
            if(index == 0) {
              this.orgArray = array;
              this.orgArray.forEach((jtem, idx) => {
                queryMattersDepartments({typeId: jtem.id}).then(res => {
                  if(res.code && res.code == 200) {
                    this.$set(this.orgArray[idx], 'list', res.data || []);
                    this.selectorObj.orgSelector = jtem;
                    if(this.orgArray[idx].list.length > 0) {
                      this.selectorObj.departmentSelector = this.orgArray[idx].list[0];
                      this.params.orgId = this.selectorObj.departmentSelector.ORGID;
                      this.params.orgName = this.selectorObj.departmentSelector.ORGNAME;
                      this.getData();
                      return
                    }
                  }
                })
              })
            } else if(index == 1) {
              this.servicers = array;
            } else if(index == 2) {
              this.eventArray = array;
            } else if(index == 3) {
              this.patterns = array;
            }
          })
        }
      });
    },
  }
}
</script>

<style lang="scss">
@import "~@/assets/css/theme/theme.scss";
#matterList{
  padding-top: 91px;
  .header {
    height: 81px;
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    .search-bar {
      width: 100%;
      height: 44px;
      padding: 8px 15px;
      box-sizing: border-box;
      display: -webkit-flex;/* Safari */
      display: flex;
      background: #fff;
      color: $c333;
      .search-box {
        height: 28px;
        line-height: 28px;
        padding: 0 15px 0 35px;
        background: #F7F7F7;
        border: 1px solid #FFFFFF;
        border-radius: 14px;
        flex: 1;
        position: relative;
        @extend .font13;
        .search-icon{
          position: absolute;
          top:0;
          left: 15px;
        }
        form{
          width: 100%;
          background: transparent;
          height: 28px;
          line-height: 28px;
          padding: 0;
          input {
            float: left;
            width: 100%;
            height: 28px;
            line-height: 28px;
            background: transparent;
            @extend .font13;
            &::-webkit-search-cancel-button{
              -webkit-appearance: none;
            }
          }
        }
      }
      .assistant{
        height: 28px;
        line-height: 28px;
        margin-left: 15px;
        @extend .font16;
      }
    }
    .department-select{
      height: 37px;
      background: #fff;
      box-sizing: border-box;
      padding: 0 15px 12px;
      border-bottom: 1px solid #F0F0F0;
      position: relative;
      .select-result{
        display: inline-flex;
        width: 25%;
        height: 24px;
        line-height: 24px;
        box-sizing: border-box;
        padding: 0 8px;
        @extend .color333;
        @extend .font14;
        span{
          display: inline-block;
          width: 100%;
          height: 24px;
          line-height: 24px;
          padding-right: 12px;
          box-sizing: border-box;
          position: relative;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          &:after{
            content: "";
            display: inline-block;
            border: 4px solid transparent;
            border-bottom: 4px solid #333;
            position: absolute;
            right: 0;
            top: 50%;
            transform: rotate(180deg);
            margin-top: -2px;
          }
          &.open:after{
            transform: rotate(0deg);
            margin-top: -9px;
          }
        }
      }
    }
  }
  .box{
    padding:0 15px;
  }
  .empty{
    margin-top: 100px;
  }
  .selector-box{
    top: 37px !important;
  }
  .dialog-bg{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background: rgba(0, 0, 0, .7);
  }
}

</style>
